import React from 'react'
import { observer, inject } from 'mobx-react'

import anchorScroll from '../../../utils/anchorScroll'

const RegistrationButton = ({ translationStore }) => {
  return (
    <div className='no-underline'>
      <a className='button' onClick={() => anchorScroll('top', '/registration')}>
        {/* {translationStore.translate('general_button_register')} */}
        Registrieren
      </a>
    </div>
  )
}

export default inject('translationStore')(observer(RegistrationButton))



// WEBPACK FOOTER //
// ./src/components/Header/LoggedOffHeader/RegistrationButton.js